<template>
  <ModouiContentHeading title="Manage Teams" />
</template>
